import httpClient from "Api/httpClient";

const END_POINT = "/transaction_documents";

const getTransactionDocuments = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getTransactionDocument = (document_id) => {
    if (!document_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + document_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printTransactionDocument = (document_id) => {
    if (!document_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?document_id=" + document_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createTransactionDocuments = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateTransactionDocuments = (payload, document_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + document_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteTransactionDocuments = (document_id) => {
    const DELETE_END_POINT = END_POINT + "/" + document_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getTransactionDocuments, getTransactionDocument, printTransactionDocument, createTransactionDocuments, updateTransactionDocuments, deleteTransactionDocuments };
